import ImageSkeleton from './ImageSkeleton';

export default ImageSkeleton;
